import { render, staticRenderFns } from "./amendDialog.vue?vue&type=template&id=de72f1ee&scoped=true"
import script from "./amendDialog.vue?vue&type=script&lang=js"
export * from "./amendDialog.vue?vue&type=script&lang=js"
import style0 from "./amendDialog.vue?vue&type=style&index=0&id=de72f1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de72f1ee",
  null
  
)

export default component.exports